import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTranslate } from "react-polyglot";
import { useDialogs } from "../Providers/Common/DialogsProvider.jsx";
import { useAuth } from "../Providers/Auth/AuthProvider.jsx";
import { useBaseData } from "../Providers/Data/BaseDataProvider.jsx";

/**
 * Обработчик роута вида "/:subjectId/learn/:deckId".
 * Меняет текущий предмет при необходимости и выполняет редирект на "/learn/:deckId".
 */
const SubjectLearnRedirect = () => {
  const { companyName, subjectId, deckId } = useParams();
  const history = useHistory();
  const t = useTranslate();
  const { user } = useAuth();
  const { subject, chooseSubject } = useBaseData();
  const { error } = useDialogs();

  useEffect(() => {
    let isCancelled = false;

    /**
     * Выполняет проверку авторизации, смену предмета (если нужно) и редирект.
     */
    const process = async () => {
      const isLoggedIn = !!(user && user.token);

      if (!isLoggedIn) {
        // Если роут содержит companyName, редиректим на "/:companyName/auth",
        // иначе используем стандартный "/auth".
        if (companyName) {
          history.replace(`/${companyName}/auth`);
        } else {
          history.replace("/auth");
        }
        return;
      }

      const routeSubjectId = parseInt(subjectId, 10);
      if (!routeSubjectId || Number.isNaN(routeSubjectId)) {
        error(t("subjectChangeError"));
        history.replace("/");
        return;
      }

      const currentSubjectId = subject?.subjectId;

      if (currentSubjectId === routeSubjectId) {
        history.replace(`/learn/${deckId}`);
        return;
      }

      const ok = await chooseSubject(routeSubjectId);
      if (isCancelled) return;

      if (ok) {
        history.replace(`/learn/${deckId}`);
      } else {
        error(t("subjectChangeError"));
        history.replace("/");
      }
    };

    process();

    return () => {
      isCancelled = true;
    };
  }, [user, subject, subjectId, deckId, companyName, chooseSubject, history, error, t]);

  return null;
};

export default SubjectLearnRedirect;
